import { render, staticRenderFns, recyclableRender, components } from "./detail.vue?vue&type=template&id=06a63f20&scoped=true&"
var renderjs
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=06a63f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a63f20",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uce-article/pages/detail.vue"
export default component.exports